/**
 * Error keys returned by the `EnhancedContentPublishConductor` on the backend.
 */
const EnhancedContentPublishErrorKeys = {
    SEARCH_UPLOAD_ERROR: "EnhancedContent.SEARCH_UPLOAD_ERROR",
    SEARCH_DELETE_ERROR: "EnhancedContent.SEARCH_DELETE_ERROR",
};

export default EnhancedContentPublishErrorKeys;
